import { md5 } from '@nu-art/ts-common';
export const ICD_Chapter_I = 'I';
export const ICD_Chapter_II = 'II';
export const ICD_Chapter_III = 'III';
export const ICD_Chapter_IV = 'IV';
export const ICD_Chapter_V = 'V';
export const ICD_Chapter_VI = 'VI';
export const ICD_Chapter_VII = 'VII';
export const ICD_Chapter_VIII = 'VIII';
export const ICD_Chapter_IX = 'IX';
export const ICD_Chapter_X = 'X';
export const ICD_Chapter_XI = 'XI';
export const ICD_Chapter_XII = 'XII';
export const ICD_Chapter_XIII = 'XIII';
export const ICD_Chapter_XIV = 'XIV';
export const ICD_Chapter_XV = 'XV';
export const ICD_Chapter_XVI = 'XVI';
export const ICD_Chapter_XVII = 'XVII';
export const ICD_Chapter_XVIII = 'XVIII';
export const ICD_Chapter_XIX = 'XIX';
export const ICD_Chapter_XX = 'XX';
export const ICD_Chapter_XXI = 'XXI';
export const ICD_Chapter_XXII = 'XXII';
export const ICD10Chapters = [
    ICD_Chapter_I,
    ICD_Chapter_II,
    ICD_Chapter_III,
    ICD_Chapter_IV,
    ICD_Chapter_V,
    ICD_Chapter_VI,
    ICD_Chapter_VII,
    ICD_Chapter_VIII,
    ICD_Chapter_IX,
    ICD_Chapter_X,
    ICD_Chapter_XI,
    ICD_Chapter_XII,
    ICD_Chapter_XIII,
    ICD_Chapter_XIV,
    ICD_Chapter_XV,
    ICD_Chapter_XVI,
    ICD_Chapter_XVII,
    ICD_Chapter_XVIII,
    ICD_Chapter_XIX,
    ICD_Chapter_XX,
    ICD_Chapter_XXI,
    ICD_Chapter_XXII,
];
// default tag names
export const ICDMappingRootTag = 'ICD Mapping';
export const ICDGeneratedVariables = 'ICD Generated Variables';
export const ICDUpdatedVariables = 'ICD Updated Variables';
export const ICDVariablesToReview = 'ICD Variables to Review';
// system tag names
export const SystemName_HematologyLymphatic = 'Hematologic - Lymphatic';
export const SystemName_EndocrineMetabolic = 'Endocrine - Metabolic';
export const SystemName_PsychiatricBehavioral = 'Psychiatric - Behavioral';
export const SystemName_CNS = 'CNS';
export const SystemName_Ophthalmic = 'Ophthalmic';
export const SystemName_HEENT = 'HEENT';
export const SystemName_CVS = 'CVS';
export const SystemName_Respiratory = 'Respiratory';
export const SystemName_GIT = 'GIT';
export const SystemName_Skin = 'Skin';
export const SystemName_MSK = 'MSK';
export const SystemName_Genitourinary = 'Genitourinary';
// default configuration consts
export const DefaultICDVersion = 10;
export const DefaultICDRelease = 2019;
export const DefaultICDOAuthEndpoint = 'https://icdaccessmanagement.who.int/connect/token';
export const DefaultICDEndpoint = 'http://id.who.int/icd/release';
export const DefaultLevenshteinThreshold = 2;
export const DefaultFittingVariablesThreshold = 3;
export const DefaultSlackChannel = 'icd-mapping';
export const DefaultQueueParallelItems = 50;
// default predb tags consts
const ICDRootTagId = md5(ICDMappingRootTag);
const RootICDMappingTag = {
    _id: ICDRootTagId, // make sure ID is constant
    label: ICDMappingRootTag,
    tagIds: []
};
const generatedVariablesTagId = md5(`${ICDMappingRootTag}/${ICDGeneratedVariables}`);
const ICDGeneratedVariablesTag = {
    _id: generatedVariablesTagId, // make sure ID is constant
    label: ICDGeneratedVariables,
    tagIds: [ICDRootTagId]
};
const updatedVariablesTagId = md5(`${ICDMappingRootTag}/${ICDUpdatedVariables}`);
const ICDUpdatedVariablesTag = {
    _id: updatedVariablesTagId, // make sure ID is constant
    label: ICDUpdatedVariables,
    tagIds: [ICDRootTagId]
};
const variablesToReviewTagId = md5(`${ICDMappingRootTag}/${ICDVariablesToReview}`);
const ICDVariablesToReviewTag = {
    _id: variablesToReviewTagId, // make sure ID is constant
    label: ICDVariablesToReview,
    tagIds: [ICDRootTagId]
};
export const ICDMapping_TagsToCreate = [RootICDMappingTag, ICDVariablesToReviewTag, ICDUpdatedVariablesTag, ICDGeneratedVariablesTag];
//# sourceMappingURL=consts.js.map